import { render, staticRenderFns } from "./darkxiyou.vue?vue&type=template&id=4849a1a3&scoped=true"
import script from "./darkxiyou.vue?vue&type=script&lang=js"
export * from "./darkxiyou.vue?vue&type=script&lang=js"
import style0 from "./darkxiyou.vue?vue&type=style&index=0&id=4849a1a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4849a1a3",
  null
  
)

export default component.exports